import React from "react";
import { getCsrfCookieDiagnostic } from "../auth/csrfDiagnostics";

/**
 * Displays CSRF cookie visibility for diagnostics — never shows token values.
 * @param {{ diagnostic?: import('../auth/csrfDiagnostics').CsrfCookieDiagnostic|null, isAuthenticated?: boolean, compact?: boolean }} props
 */
export default function CsrfCookieDiagnosticDisplay({
  diagnostic: diagnosticProp,
  isAuthenticated = false,
  compact = false,
}) {
  const diagnostic =
    diagnosticProp || getCsrfCookieDiagnostic({ isAuthenticated });

  return (
    <>
      <dt>{compact ? "CSRF (JS)" : "CSRF cookie (JavaScript visibility)"}</dt>
      <dd>
        {diagnostic.shortLabel}
        {!compact ? (
          <p className="cs-inline-note cs-csrf-diag__note">{diagnostic.detailNote}</p>
        ) : null}
      </dd>
    </>
  );
}
